import { inject, Injectable } from '@angular/core';
import { TranslationTokenService } from '@core/translations/translation-token.service';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppMissingTranslationHandler implements MissingTranslationHandler {
    private translationTokenService: TranslationTokenService = inject(TranslationTokenService);

    public handle(params: MissingTranslationHandlerParams): string {
        const defaultText = params.interpolateParams?.['defaultText'];
        if (typeof defaultText === 'string' && defaultText.trim()) return defaultText;

        if (!environment.debug) return params.key;

        const translationWithParams = this.getTranslationWithParams(params);
        if (translationWithParams) return translationWithParams;

        return this.humanizeKey(params.key);
    }

    private getTranslationWithParams(params: MissingTranslationHandlerParams): string | null {
        if (!params.interpolateParams) return null;

        return this.translationTokenService.getInterpolatedTranslationByKey(
            params.key,
            params.interpolateParams as Record<string, string | number>
        );
    }

    private humanizeKey(key: string): string {
        const lastKeyPart = key.split('.').pop();
        const fallback = (lastKeyPart ?? key).trim().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').toLowerCase();

        if (!fallback.length) return key;

        return fallback.charAt(0).toUpperCase() + fallback.slice(1);
    }
}
